
import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next';
import { SuccessIcon, ErrorIcon } from '../../components/CustomIcons';
import CustomHeader from '../../components/CustomHeader';
import wsclients from '../../services/wsclients';
import { paths } from '../../config/router.config';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
}));

export default function VumatelSms(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [result, setResult] = useState(null);
    const [contact, setContact] = useState(null);
    const [showTextRedirect, setShowTextRedirect] = useState(undefined);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        onShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        // var vumatel_order = url.searchParams.get("vumatel_order");
        let vumatel_order = null;
        if(url.pathname && url.pathname.includes("/vumatel/sms/")){
            let strPathName = url.pathname.split("/vumatel/sms/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                vumatel_order = strPathName[1];
            }
        }

        console.log("vumatel_order==", vumatel_order);
        if(vumatel_order){
            await onGetOrderStatus(vumatel_order);
        }
        onShowLoading(false)
    }

    const onGetOrderStatus = async (vumatel_order) => {
        try {
            var result = await wsclients.lab4services.getOrderStatusV2(null, vumatel_order);
            console.log("onGetOrderStatus result====", result);
            if(result.code == 'OK'){
                if(result.data && result.data.vumatelPaymentUrl) {
                    setShowTextRedirect(true);
                    window.location.href = result.data.vumatelPaymentUrl;
                }
            }else{
                setShowTextRedirect(false);
                onShowMessage({
                    show: true,
                    content: t('Get Order Status failed.'),                    
                });
            }
        }
        catch (ex) {
            console.log("getOrderStatus exception===", ex);
        }
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    return (
        <Grid item xs={12}>
            {/* <CustomHeader hideMenu={true} nomargin={true}/> */}
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {showTextRedirect && <Typography variant='body2'>{t('wait_to_redirect_payment')}</Typography>}
                    {showTextRedirect === false && <Typography variant='body2'>{t('not_found_url_payment')}</Typography>}
                    {result && result.status === 'success' && <SuccessIcon style={{ fontSize: 50 }} />}
                    {result && result.status === 'failed' && <ErrorIcon style={{ fontSize: 50 }} />}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {result && result.status === 'success' && <Typography variant='body2'>{message ? message : t('PAYMENT_SUCCESS')}</Typography>}
                    {result && result.status === 'failure' && <Typography variant='body2'>{message ? message : t('PAYMENT_FAILED')}</Typography>}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    <Button variant='contained' onClick={() => history.push(paths.home)}>{t('btn_back_to_home')}</Button>
                </Grid>
            </Grid>
            {showLoading && <CustomLoading open={showLoading} />}
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={message.action ? message.action : () => onShowMessage({})}
            />}
        </Grid>
    );
}